import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
interface CtaButtonProps {
  text: string;
  onClick?: () => void;
}
export function CtaButton({
  text,
  onClick
}: CtaButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.location.href = 'https://pay.hotmart.com/S105209396R?checkoutMode=10';
    }
  };
  return <div className="flex flex-col items-center" data-id="element-70">
      <motion.button onClick={handleClick} className="w-full max-w-2xl bg-red-600 text-white font-black text-xl md:text-2xl py-6 px-8 rounded-xl shadow-2xl hover:bg-red-700 transition-colors" animate={{
      scale: [1, 1.04, 1],
      boxShadow: ['0 0 0 0 rgba(220, 38, 38, 0.4)', '0 0 0 16px rgba(220, 38, 38, 0)', '0 0 0 0 rgba(220, 38, 38, 0)']
    }} transition={{
      duration: 1.5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.97
    }} data-id="element-71">
        {text}
      </motion.button>

      <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-4 text-xs md:text-sm font-bold text-amber-600" data-id="element-72">
        <div className="flex items-center gap-1.5" data-id="element-73">
          <LockIcon className="w-4 h-4 text-amber-500" data-id="element-74" />
          <span data-id="element-75">Bank-Level Security</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-76">
          <ShieldCheckIcon className="w-4 h-4 text-amber-500" data-id="element-77" />
          <span data-id="element-78">7-Day Guarantee</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-79">
          <CreditCardIcon className="w-4 h-4 text-amber-500" data-id="element-80" />
          <span data-id="element-81">One-Time Payment, No Subscriptions</span>
        </div>
      </div>
    </div>;
}